module.exports = __webpack_public_path__ + "img/10.e12ef39b.jpeg";